package org.solyton.solawi.bid.application.ui.page.shares

import androidx.compose.runtime.*
import io.ktor.http.*
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.launch
import org.evoleq.compose.Markup
import org.evoleq.compose.conditional.When
import org.evoleq.compose.effect.LaunchedEffectOnSource
import org.evoleq.compose.layout.Horizontal
import org.evoleq.compose.routing.navigate
import org.evoleq.compose.style.data.device.DeviceType
import org.evoleq.device.data.mediaType
import org.evoleq.kotlinx.date.now
import org.evoleq.language.Lang
import org.evoleq.language.subComp
import org.evoleq.language.texts
import org.evoleq.math.*
import org.evoleq.optics.lens.BiMap
import org.evoleq.optics.lens.DeepSearch
import org.evoleq.optics.lens.FilterBy
import org.evoleq.optics.lens.FirstBy
import org.evoleq.optics.storage.*
import org.evoleq.optics.transform.flatMap
import org.evoleq.optics.transform.times
import org.evoleq.uuid.NIL_UUID
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.letsPlot.commons.intern.filterNotNullValues
import org.solyton.solawi.bid.application.data.Application
import org.solyton.solawi.bid.application.data.transform.banking.bankingApplicationIso
import org.solyton.solawi.bid.application.data.transform.distribution.distributionManagementIso
import org.solyton.solawi.bid.application.data.transform.shares.shareManagementIso
import org.solyton.solawi.bid.application.data.transform.user.userIso
import org.solyton.solawi.bid.application.ui.page.user.style.listItemWrapperStyle
import org.solyton.solawi.bid.module.banking.action.readBankAccounts
import org.solyton.solawi.bid.module.banking.action.readFiscalYears
import org.solyton.solawi.bid.module.banking.action.readPersonalCreditorIdentifier
import org.solyton.solawi.bid.module.banking.action.readPersonalLegalEntity
import org.solyton.solawi.bid.module.banking.action.sepa.*
import org.solyton.solawi.bid.module.banking.component.form.sepa.PartialSepaCollection
import org.solyton.solawi.bid.module.banking.data.*
import org.solyton.solawi.bid.module.banking.data.api.*
import org.solyton.solawi.bid.module.banking.data.application.BankingApplication
import org.solyton.solawi.bid.module.banking.data.application.bankAccounts
import org.solyton.solawi.bid.module.banking.data.application.creditorIdentifier
import org.solyton.solawi.bid.module.banking.data.application.fiscalYears
import org.solyton.solawi.bid.module.banking.data.application.legalEntity
import org.solyton.solawi.bid.module.banking.data.application.sepaModule
import org.solyton.solawi.bid.module.banking.data.bankaccount.AccountType
import org.solyton.solawi.bid.module.banking.data.creditor.identifier.CreditorIdentifier
import org.solyton.solawi.bid.module.banking.data.fiscalyear.format
import org.solyton.solawi.bid.module.banking.data.legalentity.legalEntityId
import org.solyton.solawi.bid.module.banking.data.sepa.SepaSequenceType
import org.solyton.solawi.bid.module.banking.data.sepa.collection.SepaCollection
import org.solyton.solawi.bid.module.banking.data.sepa.mandate.SepaMandate
import org.solyton.solawi.bid.module.banking.data.sepa.sepaCollections
import org.solyton.solawi.bid.module.banking.service.sepa.generateReference
import org.solyton.solawi.bid.module.constants.CHECK_FALSE
import org.solyton.solawi.bid.module.constants.CHECK_TRUE
import org.solyton.solawi.bid.module.constants.checkIcon
import org.solyton.solawi.bid.module.control.button.*
import org.solyton.solawi.bid.module.control.dropdown.Dropdown
import org.solyton.solawi.bid.module.control.dropdown.SimpleUpDown
import org.solyton.solawi.bid.module.dialog.component.WarningSymbol
import org.solyton.solawi.bid.module.dialog.component.showDialogModal
import org.solyton.solawi.bid.module.dialog.i18n.dialogModalTexts
import org.solyton.solawi.bid.module.distribution.action.readDistributionPoints
import org.solyton.solawi.bid.module.distribution.data.distributionManagementActions
import org.solyton.solawi.bid.module.distribution.data.distributionpoint.DistributionPoint
import org.solyton.solawi.bid.module.distribution.data.management.DistributionManagement
import org.solyton.solawi.bid.module.distribution.data.management.distributionPoints
import org.solyton.solawi.bid.module.list.component.*
import org.solyton.solawi.bid.module.page.component.Page
import org.solyton.solawi.bid.module.scrollable.ScrollableStyles
import org.solyton.solawi.bid.module.scrollable.VirtualScrollableList
import org.solyton.solawi.bid.module.search.component.SearchInput
import org.solyton.solawi.bid.module.search.component.SearchInputStyles
import org.solyton.solawi.bid.module.shares.action.*
import org.solyton.solawi.bid.module.shares.component.modal.*
import org.solyton.solawi.bid.module.shares.data.api.UpdateShareStatus
import org.solyton.solawi.bid.module.shares.data.internal.ChangedBy
import org.solyton.solawi.bid.module.shares.data.internal.ShareStatus
import org.solyton.solawi.bid.module.shares.data.management.ShareManagement
import org.solyton.solawi.bid.module.shares.data.management.deviceData
import org.solyton.solawi.bid.module.shares.data.management.shareOffers
import org.solyton.solawi.bid.module.shares.data.management.shareSubscriptions
import org.solyton.solawi.bid.module.shares.data.management.shareTypes
import org.solyton.solawi.bid.module.shares.data.offers.ShareOffer
import org.solyton.solawi.bid.module.shares.data.shareManagementActions
import org.solyton.solawi.bid.module.shares.data.shareManagementModals
import org.solyton.solawi.bid.module.shares.data.subscriptions.ShareSubscription
import org.solyton.solawi.bid.module.shares.data.subscriptions.ShareSubscriptions
import org.solyton.solawi.bid.module.shares.data.toApiType
import org.solyton.solawi.bid.module.shares.data.types.ShareType
import org.solyton.solawi.bid.module.shares.data.values.ShareSubscriptionId
import org.solyton.solawi.bid.module.shares.data.values.ShareTypeId
import org.solyton.solawi.bid.module.shares.service.hasAssociatedSepaMandate
import org.solyton.solawi.bid.module.shares.service.refersTo
import org.solyton.solawi.bid.module.shares.service.relatedBankAccountExists
import org.solyton.solawi.bid.module.style.card.cardStyle
import org.solyton.solawi.bid.module.style.list.cardListStyles
import org.solyton.solawi.bid.module.style.overflow.Overflow
import org.solyton.solawi.bid.module.style.overflow.overflow
import org.solyton.solawi.bid.module.style.page.PageTitle
import org.solyton.solawi.bid.module.style.page.SubTitle
import org.solyton.solawi.bid.module.style.page.verticalPageStyle
import org.solyton.solawi.bid.module.style.wrap.Wrap
import org.solyton.solawi.bid.module.user.action.organization.readOrganizations
import org.solyton.solawi.bid.module.user.action.user.getUsers
import org.solyton.solawi.bid.module.user.action.user.readUserProfiles
import org.solyton.solawi.bid.module.user.component.dropdown.dropdownStyles
import org.solyton.solawi.bid.module.user.data.UserApplication
import org.solyton.solawi.bid.module.user.data.managed.id
import org.solyton.solawi.bid.module.user.data.managedUsers
import org.solyton.solawi.bid.module.user.data.organization.members
import org.solyton.solawi.bid.module.user.data.profile.UserProfile
import org.solyton.solawi.bid.module.user.data.user
import org.solyton.solawi.bid.module.user.data.user.organizations
import org.solyton.solawi.bid.module.user.data.user.username
import org.solyton.solawi.bid.module.user.data.userActions
import org.solyton.solawi.bid.module.user.service.profile.fullname
import org.solyton.solawi.bid.module.values.*

data class CheckedShareSubscription(val checked: Boolean, val shareSubscription: ShareSubscription)
data class ShareSubscriptionFilter(
    val fiscalYears: List<FiscalYearId>? = null,
    val shareTypes: List<ShareTypeId>? = null,
    val statuses: List<ShareStatus>? = null,
    val isAhcAuthorized: Boolean? = null,
    val userProfiles: List<String>? = null,
    val distributionPoints: List<String>? = null,
    val sepaCollections: List<SepaCollectionId>? = null
)

@Markup
@Composable
@Suppress("FunctionName", "CyclomaticComplexMethod", "CognitiveComplexMethod")
fun ShareManagementForOrganizationsPage(storage: Storage<Application>, providerId: ProviderId, up: String) {
    val scope = rememberCoroutineScope()

    val shareManagementStore = storage * shareManagementIso
    val shareManagementActions = shareManagementStore * shareManagementActions

    val distributionManagementStorage = storage * distributionManagementIso
    val distributionManagementActions = distributionManagementStorage * distributionManagementActions

    val bankingApplicationStorage = storage * bankingApplicationIso
    val bankingApplicationActions = bankingApplicationStorage * bankingApplicationActions
    val legalEntityStorage = bankingApplicationStorage * legalEntity
    val isLegalEntityDefined = Read(legalEntityStorage * legalEntityId) map { it.value != NIL_UUID }

    val userStorage = storage * userIso
    val userActions = userStorage * userActions
    val organizationsStorage = userStorage * user * organizations
    val organizationStorage = organizationsStorage * DeepSearch { it.organizationId == providerId.value }
    val memberStorage = organizationStorage * members
    val usersStorage = storage * userIso * managedUsers

    LaunchedEffect(providerId) {
        launch {
            shareManagementActions dispatch readShareTypes(providerId.value)
        }
        launch {
            shareManagementActions dispatch readShareOffers(providerId.value)
        }
        launch {
            shareManagementActions dispatch readShareSubscriptions(providerId.value)
        }
        launch {
            distributionManagementActions dispatch readDistributionPoints(providerId.value)
        }
        launch {
           bankingApplicationActions dispatch readFiscalYears(providerId.value)
        }
        launch {
            bankingApplicationActions dispatch readBankAccounts(LegalEntityId(providerId.value))
        }
        launch {
            bankingApplicationActions dispatch readPersonalCreditorIdentifier(
                LegalEntityId(providerId.value),
                onError = { (statusCode, _) ->
                    {
                        when (statusCode) {
                            HttpStatusCode.NotFound -> it
                            else -> it
                        }
                    }
                }
            )
        }
        launch {
            userActions dispatch readOrganizations()

        }
        launch {
            userActions dispatch getUsers(providerId.value)
        }
    }
    if(organizationsStorage.read().isEmpty()) return
    if(usersStorage.read().isEmpty()) return
    LaunchedEffect(usersStorage.read()) {
        launch {
            userActions dispatch readUserProfiles(memberStorage.read().map { it.memberId })
        }
    }

    LaunchedEffect(providerId) {
        launch {
            bankingApplicationActions dispatch readPersonalLegalEntity(
                partyId = providerId.value,
                onError = { (statusCode, _) ->
                    {
                        when (statusCode) {
                            HttpStatusCode.NotFound -> it
                            else -> it
                        }
                    }
                },
            )
        }
    }

    LaunchedEffectOnSource(isLegalEntityDefined)  {
        if(isLegalEntityDefined.emit()) {
            launch {
                bankingApplicationActions dispatch readPersonalSepaCollections(LegalEntityId(providerId.value))
            }
            launch {
                bankingApplicationActions dispatch readSepaMessagesByLegalEntity(LegalEntityId(providerId.value))
            }
            launch {
                bankingApplicationActions dispatch readSepaMandatesByCreditorsLegalEntity(LegalEntityId(providerId.value))
            }
        }
    }

    val deviceType = shareManagementStore * deviceData * mediaType.get

    val texts = shareManagementForOrganizationsTexts()

    Page(verticalPageStyle) {
        Wrap{
            Horizontal(styles = {
                justifyContent(JustifyContent.SpaceBetween)
                alignItems(AlignItems.Center)
                width(100.percent)
            }) {
                PageTitle("Share Management for Organizations")
                Horizontal {
                    ArrowUpButton(
                        Color.black,
                        Color.white,
                        { "UP" },
                        deviceType,
                        false,
                    ) {
                        navigate(up)
                    }
                }
            }
            SubTitle("Manage share types, offers and subscriptions of your organization.")
        }

        ShareTypeManagement(
            scope,
            shareManagementStore,
            texts * subComp("shareTypeManagement"),
            deviceType,
            providerId,
        )

        ShareOfferManagement(
            scope,
            shareManagementStore,
            bankingApplicationStorage,
            texts * subComp("shareOfferManagement"),
            deviceType,
            providerId,
        )

        val fiscalYears = bankingApplicationStorage * fiscalYears
        val currentFiscalYear = fiscalYears * FirstOrNull { now().date in it.start..it.end }
        var filter by remember{ mutableStateOf( ShareSubscriptionFilter(
            fiscalYears = currentFiscalYear.read()?.let{
                listOf(FiscalYearId(it.fiscalYearId))
            },
            statuses = listOf(ShareStatus.Subscribed),
            isAhcAuthorized = true,
        ))}
        val uiState = Storage(
            read = { ShareSubscriptionManagementState(filter)},
            write = { filter = it.filter },
        )

        ShareSubscriptionManagement(
            scope,
            shareManagementStore,
            distributionManagementStorage,
            userStorage,
            bankingApplicationStorage,
            uiState,
            texts * subComp("shareSubscriptionManagement"),
            deviceType,
            providerId,
        )
    }
}

@Markup
@Composable
@Suppress("UnusedParameter")
fun ShareTypeManagement(
    scope: CoroutineScope,
    shareManagementStore: Storage<ShareManagement>,
    texts: Source<Lang.Block>,
    deviceType: Source<DeviceType>,
    providerId: ProviderId,
) {
    val shareManagementModals = shareManagementStore * shareManagementModals
    val shareManagementActions = shareManagementStore * shareManagementActions

    val shareTypes = shareManagementStore * shareTypes


    Wrap({
        cardStyle()
    }) {
        ListWrapper(cardListStyles.listWrapper) {
            var opened by remember { mutableStateOf(false) }
            TitleWrapper(cardListStyles.titleWrapper) {
                Title { H3 { Text("Share Types") } }
                var shareTypeState by remember { mutableStateOf<ShareType?>(null) }

                Horizontal(styles = {
                    flexGrow(1.0)
                    justifyContent(JustifyContent.FlexEnd)
                }) {
                    When(opened) {
                        PlusButton(
                            color = Color.black,
                            bgColor = Color.white,
                            deviceType = deviceType,
                        ) {
                            shareManagementModals.showUpsertShareTypeModal(
                                shareManagementStore,
                                dialogModalTexts(""),
                                deviceType,
                                providerId,
                                shareTypeState,
                                { point ->
                                    shareTypeState = point
                                }) {
                                val state = shareTypeState
                                requireNotNull(state)
                                scope.launch {
                                    shareManagementActions dispatch createShareType(
                                        providerId.value,
                                        state.name,
                                        state.key,
                                        state.description,
                                    )
                                }
                            }
                        }
                    }
                    CardChevrons(
                        texts = Source{cardChevronTexts()},
                        deviceType = deviceType,
                        opened = opened
                    ) {
                        opened = it
                    }
                }
            }
            When(opened) {
                HeaderWrapper {
                    Header(cardListStyles.header) {
                        HeaderCell("Name") { width(20.percent) }
                        HeaderCell("key") { width(10.percent) }
                        HeaderCell("Description") { width(70.percent) }
                    }
                }
                ListItemsIndexed(shareTypes.read()) { index, shareType ->
                    ListItemWrapper({
                        listItemWrapperStyle(this, index)
                    }) {
                        DataWrapper(cardListStyles.dataWrapper) {
                            TextCell(shareType.name) { width(20.percent) }
                            TextCell(shareType.key) { width(10.percent) }
                            TextCell(shareType.description) { width(70.percent) }

                        }
                        ActionsWrapper {
                            var shareTypeState by remember { mutableStateOf<ShareType>(shareType) }
                            EditButton(
                                color = Color.black,
                                bgColor = Color.white,
                                deviceType = deviceType,
                            ) {
                                shareManagementModals.showUpsertShareTypeModal(
                                    shareManagementStore,
                                    dialogModalTexts(""),
                                    deviceType,
                                    providerId,
                                    shareTypeState,
                                    { point ->
                                        shareTypeState = point
                                    }) {
                                    val state = shareTypeState
                                    requireNotNull(state)
                                    scope.launch {
                                        shareManagementActions dispatch updateShareType(
                                            shareType.shareTypeId,
                                            providerId.value,
                                            state.name,
                                            state.key,
                                            state.description
                                        )
                                    }
                                }
                            }
                            TrashCanButton(
                                color = Color.black,
                                bgColor = Color.white,
                                deviceType = deviceType,
                                isDisabled = true
                            ) {

                            }
                        }
                    }
                }
            }
        }
    }
}

@Markup
@Composable
@Suppress("UNUSED_PARAMETER", "CyclomaticComplexMethod")
fun ShareOfferManagement(
    scope: CoroutineScope,
    shareManagementStore: Storage<ShareManagement>,
    bankingApplicationStorage: Storage<BankingApplication>,
    texts: Source<Lang.Block>,
    deviceType: Source<DeviceType>,
    providerId: ProviderId,
) {
    // Share Management stuff
    val shareManagementModals = shareManagementStore * shareManagementModals
    val shareManagementActions = shareManagementStore * shareManagementActions

    val shareTypes = shareManagementStore * shareTypes
    val shareOffers = shareManagementStore * shareOffers

    // Banking stuff
    val bankingApplicationActions = bankingApplicationStorage * bankingApplicationActions
    val debtorBankAccounts = bankingApplicationStorage * bankAccounts * FilterBy { it.bankAccountType == AccountType.DEBTOR }
    val fiscalYears = bankingApplicationStorage * fiscalYears
    val creditorIdentifier = bankingApplicationStorage * creditorIdentifier
    val creditorBankAccounts = bankingApplicationStorage * bankAccounts * FilterBy { it.bankAccountType == AccountType.CREDITOR }
    val sepaModule = bankingApplicationStorage * sepaModule
    val sepaCollections = sepaModule * sepaCollections





    Wrap({
        cardStyle()
    }) {
        var opened by remember { mutableStateOf(false) }
        key((sepaCollections * Size()).emit()) {
            ListWrapper(cardListStyles.listWrapper) {
                TitleWrapper {
                    Title { H3 { Text("Share Offers") } }
                    var shareOfferState by remember { mutableStateOf<ShareOffer?>(null) }
                    Horizontal(styles = {
                        flexGrow(1.0)
                        justifyContent(JustifyContent.FlexEnd)
                    }) {
                        When(opened) {
                            PlusButton(
                                color = Color.black,
                                bgColor = Color.white,
                                deviceType = deviceType,
                            ) {
                                shareManagementModals.showUpsertShareOffersModal(
                                    shareManagementStore,
                                    dialogModalTexts(""),
                                    deviceType,
                                    fiscalYears.read(),
                                    shareTypes.read(),
                                    shareOfferState,
                                    { state ->
                                        shareOfferState = state
                                    }) {
                                    val state = shareOfferState
                                    requireNotNull(state)
                                    scope.launch {
                                        shareManagementActions dispatch createShareOffer(
                                            providerId.value,
                                            state.shareType.shareTypeId,
                                            state.fiscalYear.fiscalYearId,
                                            state.price,
                                            state.pricingType,
                                            state.ahcAuthorizationRequired,
                                        )
                                    }
                                }
                            }
                        }
                        CardChevrons(
                            texts = Source { cardChevronTexts() },
                            deviceType = deviceType,
                            opened = opened
                        ) {
                            opened = it
                        }
                    }
                }
                When(opened) {
                    HeaderWrapper {
                        Header(cardListStyles.header) {
                            HeaderCell("Fiscal Year") { width(10.percent) }
                            HeaderCell("Share Type") { width(20.percent) }
                            HeaderCell("Price") { width(10.percent) }
                            HeaderCell("PricingType") { width(10.percent) }
                            HeaderCell("SEPA required") { width(10.percent) }
                            HeaderCell("SEPA - Collection Key / Mandate Ref Prefix") { width(40.percent) }
                        }
                    }
                    ListItemsIndexed(shareOffers.read().let {
                        it.sortedByDescending { s -> s.fiscalYear.format() }
                    }) { index, shareOffer ->
                        ListItemWrapper({
                            listItemWrapperStyle(this, index)
                        }) {
                            val booleansMap: Map<String, Boolean> = mapOf(
                                CHECK_TRUE to true,
                                CHECK_FALSE to false
                            )

                            fun getKeyOf(value: Boolean): String = booleansMap.filter { it.value == value }.keys.first()
                            val sepaCollections =
                                sepaCollections * FilterBy { shareOffer.shareOfferId in it.referenceIds.map { ref -> ref.value } }

                            DataWrapper(cardListStyles.dataWrapper) {
                                TextCell(shareOffer.fiscalYear.format()) { width(10.percent) }
                                TextCell(shareOffer.shareType.name) { width(20.percent) }
                                TextCell("${shareOffer.price ?: "--"}") { width(10.percent) }
                                TextCell(shareOffer.pricingType.name) { width(10.percent) }
                                TextCell(getKeyOf(shareOffer.ahcAuthorizationRequired)) { width(10.percent) }
                                TextCell(sepaCollections.read().joinToString(", ") { sC ->
                                    "${sC.collectionKey.value} / ${sC.mandateReferencePrefix.value}"
                                }) {
                                    width(40.percent)
                                    overflow(Overflow.Hidden)
                                }
                            }
                            ActionsWrapper {
                                var shareOfferState by remember { mutableStateOf<ShareOffer>(shareOffer) }
                                var creditorIdentifierState by remember {
                                    mutableStateOf<CreditorIdentifier?>(
                                        creditorIdentifier.read()
                                    )
                                }

                                When(creditorIdentifierState != null) {
                                    val finalCreditorIdentifier =
                                        requireNotNull(creditorIdentifierState) { "Cannot be null " }
                                    val sepaCollectionReader =
                                        sepaCollections * FirstOrNull { shareOffer.shareOfferId in it.referenceIds.map { id -> id.value } }
                                    var sepaCollectionState by remember {
                                        mutableStateOf(
                                            PartialSepaCollection(
                                                sepaCollectionId = sepaCollectionReader.emit()?.sepaCollectionId,
                                                creditorIdentifierId = finalCreditorIdentifier.creditorIdentifierId,
                                                creditorBankAccountId = sepaCollectionReader.emit()?.creditorBankAccountId,
                                                collectionKey = sepaCollectionReader.emit()?.collectionKey,
                                                mandateReferencePrefix = sepaCollectionReader.emit()?.mandateReferencePrefix,
                                                remittanceInformation = sepaCollectionReader.emit()?.remittanceInformation,
                                                sepaSequenceType = sepaCollectionReader.emit()?.sepaSequenceType
                                                    ?: SepaSequenceType.FRST,
                                                localInstrument = sepaCollectionReader.emit()?.localInstrument,
                                                isActive = sepaCollectionReader.emit()?.isActive ?: true,
                                                leadTimesDays = sepaCollectionReader.emit()?.leadTimesDays ?: 5,
                                                requestedCollectionDay = sepaCollectionReader.emit()?.requestedCollectionDay
                                                    ?: 2,
                                                chargeBearer = sepaCollectionReader.emit()?.chargeBearer
                                                    ?: ChargeBearer("SLEV")
                                            )
                                        )
                                    }
                                    CreditCardButton(
                                        color = Color.black,
                                        bgColor = Color.white,
                                        deviceType = deviceType,
                                    ) {

                                        shareManagementModals.showAttachSepaCollectionModal(
                                            bankingApplicationStorage,
                                            texts = dialogModalTexts("Attach Sepa Collection"),
                                            device = deviceType,
                                            bankAccounts = creditorBankAccounts.read(),
                                            sepaCollection = sepaCollectionState,
                                            isOkButtonDisabled = {
                                                with(sepaCollectionState) {
                                                    creditorBankAccountId == null
                                                            || creditorIdentifierId == null
                                                            || mandateReferencePrefix == null
                                                            || collectionKey == null
                                                            || remittanceInformation == null
                                                            || sepaSequenceType == null
                                                            || leadTimesDays == null
                                                            || chargeBearer == null
                                                            || isActive == null
                                                }
                                            },
                                            setSepaCollection = { collection -> sepaCollectionState = collection }
                                        ) {
                                            when (val sepaCollectionId = sepaCollectionState.sepaCollectionId) {
                                                null, SepaCollectionId(NIL_UUID) -> {
                                                    val data = with(sepaCollectionState) {
                                                        CreateSepaCollection(
                                                            creditorIdentifierId = creditorIdentifierId!!,
                                                            creditorBankAccountId = creditorBankAccountId!!,
                                                            mandateReferencePrefix = mandateReferencePrefix!!,
                                                            remittanceInformation = remittanceInformation!!,
                                                            collectionKey = collectionKey!!,
                                                            sepaSequenceType = sepaSequenceType!!.toApiType(),
                                                            localInstrument = localInstrument,
                                                            chargeBearer = chargeBearer!!,
                                                            requestedCollectionDay = requestedCollectionDay,
                                                            leadTimeDays = leadTimesDays!!,
                                                            purposeCode = purposeCode,
                                                            isActive = isActive!!,
                                                            sepaMandates = null,
                                                            sepaPayments = null,
                                                            referenceIds = listOf(SepaCollectionReferenceId(shareOffer.shareOfferId)),
                                                        )
                                                    }

                                                    scope.launch {
                                                        bankingApplicationActions dispatch createSepaCollection(
                                                            data
                                                        )
                                                    }
                                                }

                                                else -> {
                                                    val data = with(sepaCollectionState) {
                                                        UpdateSepaCollection(
                                                            sepaCollectionId,
                                                            creditorIdentifierId = creditorIdentifierId!!,
                                                            creditorAccountId = creditorBankAccountId!!,
                                                            mandateReferencePrefix = mandateReferencePrefix!!,
                                                            collectionKey = collectionKey!!,
                                                            remittanceInformation = remittanceInformation!!,
                                                            sepaSequenceType = sepaSequenceType!!.toApiType(),
                                                            localInstrument = localInstrument,
                                                            chargeBearer = chargeBearer!!,
                                                            requestedCollectionDay = requestedCollectionDay,
                                                            leadTimeDays = leadTimesDays!!,
                                                            purposeCode = purposeCode,
                                                            isActive = isActive!!,
                                                            referenceIds = listOf(SepaCollectionReferenceId(shareOffer.shareOfferId)),
                                                        )
                                                    }

                                                    scope.launch {
                                                        bankingApplicationActions dispatch updateSepaCollection(
                                                            data
                                                        )
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                When(creditorIdentifierState == null) {
                                    CreditCardButton(
                                        color = Color.black,
                                        bgColor = Color.white,
                                        deviceType = deviceType,
                                        isDisabled = true,
                                        texts = { "No creditor identifiers defined" }
                                    ) {

                                    }
                                }
                                EditButton(
                                    color = Color.black,
                                    bgColor = Color.white,
                                    deviceType = deviceType,
                                ) {
                                    shareManagementModals.showUpsertShareOffersModal(
                                        shareManagementStore,
                                        dialogModalTexts(""),
                                        deviceType,
                                        fiscalYears.read(),
                                        shareTypes.read(),
                                        shareOfferState,
                                        { state ->
                                            shareOfferState = state
                                        }) {
                                        val state = shareOfferState
                                        requireNotNull(state)
                                        scope.launch {
                                            shareManagementActions dispatch updateShareOffer(
                                                state.shareOfferId,
                                                providerId.value,
                                                state.shareType.shareTypeId,
                                                state.fiscalYear.fiscalYearId,
                                                state.price,
                                                state.pricingType,
                                                state.ahcAuthorizationRequired,
                                            )
                                        }
                                    }
                                }
                                TrashCanButton(
                                    color = Color.black,
                                    bgColor = Color.white,
                                    deviceType = deviceType,
                                    isDisabled = true
                                ) {

                                }
                            }
                        }
                    }
                }
            }
        }
    }
}


data class ShareSubscriptionManagementState(
    val filter: ShareSubscriptionFilter
)

@Markup
@Composable
@Suppress("UNUSED_PARAMETER", "CyclomaticComplexMethod", "CognitiveComplexMethod")
fun ShareSubscriptionManagement(
    scope: CoroutineScope,
    shareManagementStore: Storage<ShareManagement>,
    distributionManagementStorage: Storage<DistributionManagement>,
    userStorage: Storage<UserApplication>,
    bankingApplicationStorage: Storage<BankingApplication>,
    uiState: Storage<ShareSubscriptionManagementState>,
    texts: Source<Lang.Block>,
    deviceType: Source<DeviceType>,
    providerId: ProviderId,
) {
    // Share Management stuff
    val shareManagementModals = shareManagementStore * shareManagementModals
    val shareManagementActions = shareManagementStore * shareManagementActions

    val shareTypes = shareManagementStore * shareTypes
    val shareOffers = shareManagementStore * shareOffers
    val shareSubscriptions = shareManagementStore * shareSubscriptions

    // Distribution Points stuff
    val distributionManagementActions = distributionManagementStorage * distributionManagementActions
    val distributionPoints = distributionManagementStorage * distributionPoints

    // Banking stuff
    val bankingApplicationActions = bankingApplicationStorage * bankingApplicationActions
    val debtorBankAccounts = bankingApplicationStorage * bankAccounts * FilterBy { it.bankAccountType == AccountType.DEBTOR }
    val fiscalYears = bankingApplicationStorage * fiscalYears
    val currentFiscalYear = fiscalYears * FirstOrNull { now().date in it.start..it.end }
    val creditorIdentifier = bankingApplicationStorage * creditorIdentifier
    val creditorBankAccounts = bankingApplicationStorage * bankAccounts * FilterBy { it.bankAccountType == AccountType.CREDITOR }
    val sepaModule = bankingApplicationStorage * sepaModule
    val sepaCollections = sepaModule * sepaCollections

    // User stuff
    val userActions = userStorage * userActions
    val organizationsStorage = userStorage * user * organizations
    val organizationStorage = organizationsStorage * DeepSearch { it.organizationId == providerId.value }
    val memberStorage = organizationStorage * members
    val usersStorage = userStorage * managedUsers
    val currentUserId = usersStorage * FirstBy { it.username == (userStorage * user * username).read() } * id
    val membersAsUsers = usersStorage * FilterBy { it.username in (memberStorage.read().map { m -> m.username }) }

    Wrap({
        cardStyle()
    }){
        val checkedMap = remember {  mutableStateMapOf<String, Boolean>() }
        fun isChecked(id: String): Boolean = checkedMap[id] ?: false
        val checkedSubscriptions = shareSubscriptions * BiMap<ShareSubscription, CheckedShareSubscription>(
            { s -> CheckedShareSubscription(isChecked(s.shareSubscriptionId), s)},
            {cS->
                checkedMap[cS.shareSubscription.shareSubscriptionId] = cS.checked
                cS.shareSubscription
            }
        )
        val fiscalYearsMap = fiscalYears.read().associateBy { it.fiscalYearId }
        val distributionPointsMap = distributionPoints.read().associateBy { it.distributionPointId }
        val shareOffersMap = shareOffers.read().associateBy { it.shareOfferId }
        val shareTypesMap = shareOffersMap.mapNotNull { it.key to it.value.shareType }.associateBy({it.first}) { it.second }
        val userProfilesMap = memberStorage.read().map{ member ->
            usersStorage.read().firstOrNull{ user -> user.id == member.memberId }?.profile
        }.mapNotNull { it }.associateBy { it.userProfileId }
        val userProfileToUserMap = memberStorage.read().mapNotNull { member ->
            usersStorage.read().firstOrNull { user -> user.id == member.memberId }
        }.associateBy { it.profile?.userProfileId }
        val userProfileToBankAccountMap = usersStorage.read().map { user ->
            val bankAccount = debtorBankAccounts * FirstOrNull { it.userId.value == user.id }
            user to bankAccount.emit()
        }.associateBy({it.first.profile?.userProfileId}) { it.second  }.filterNotNullValues()
        // val sepaCollectionsMap = sepaCollections.read().associateBy { it.sepaCollectionId }
        /*
        val sepaCollectionIdsByReference: Map<SepaCollectionReferenceId, List<SepaCollectionId>> = sepaCollections.read().flatMap { collection ->
            collection.referenceIds.map { it to collection.sepaCollectionId }
        }.distinct().groupBy ({ it.first }){it.second}
         */
        val sepaCollectionIdToReferences: Map<SepaCollectionId, List<SepaCollectionReferenceId>> = sepaCollections.read().flatMap { collection ->
            collection.referenceIds.map { collection.sepaCollectionId to it }
        }.distinct().groupBy ({ it.first }){it.second}

        val sepaMandates: Source<List<SepaMandate>> = sepaCollections flatMap { collection -> collection.sepaMandates }
        val mandatesByReferenceId = sepaMandates map {
                mandates -> mandates.flatMap{it.referenceIds.map { id -> id to it }}
            .associateBy({it.first}){it.second}
        }

        val shareSubscriptionIdToMandateMap: Source<Map<ShareSubscriptionId, SepaMandate?>> =
            Source{shareSubscriptions.read()} map{ subscriptions: List<ShareSubscription>->
                val map = mandatesByReferenceId.emit()
                subscriptions.associateBy({ ShareSubscriptionId(it.shareSubscriptionId)}) { subscription ->
                    map[SepaMandateReferenceId(subscription.shareSubscriptionId)]
                }
            }

        val shareSubscriptionToCollectionsMap: Source<Map<ShareSubscriptionId, List<SepaCollection>>> = Read(shareSubscriptions) map {
            subscriptions -> subscriptions.associateBy({ ShareSubscriptionId(it.shareSubscriptionId) }) { subscription ->
                (Read(sepaCollections) map { collections -> collections.filter {
                    collection -> collection.referenceIds.any { id ->
                        id.value == subscription.shareOfferId
                    }
                }}).emit()
            }
        }

        var opened by remember { mutableStateOf(false) }
        var allChecked by remember { mutableStateOf(false) }
        var filter by  remember { mutableStateOf(uiState.read().filter) }
        var filteredCheckedSubscriptions by remember { mutableStateOf(checkedSubscriptions.read()) }

        LaunchedEffect(
            filter,
            allChecked,
            checkedMap.filter { it.value }.keys,
            checkedMap.keys.size,
            shareSubscriptions.read().joinToString("-") { "$it" },
        ) {
            filteredCheckedSubscriptions = checkedSubscriptions.filter { (_, subscription) ->
                val matchesFiscalYears =
                    filter.fiscalYears?.let { FiscalYearId(subscription.fiscalYearId) in it } ?: true
                val matchesShareTypes =
                    filter.shareTypes?.let { ShareTypeId(shareTypesMap[subscription.shareOfferId]!!.shareTypeId) in it }
                        ?: true
                val matchesStatuses = filter.statuses?.let { subscription.status in it } ?: true
                val matchesAhcAuthorized = filter.isAhcAuthorized?.let { subscription.ahcAuthorized == it } ?: true
                val matchesUserProfiles = filter.userProfiles?.any { searchText ->
                    userProfilesMap[subscription.userProfileId]?.fullname()
                        ?.contains(searchText, ignoreCase = true) == true
                } ?: true
                val matchesDistributionPoints = filter.distributionPoints?.let { subscription.distributionPointId in it }?: true
                val matchesSepaCollections = filter.sepaCollections?.let { collections ->
                    when{
                        collections.isEmpty() -> true
                        // no sepa mandate associated
                        collections.size == 1 && collections.first().value == NIL_UUID ->
                            sepaCollections.none{ collection -> collection.mandateReferenceIds.values.any { it.any{id -> id.value == subscription.shareSubscriptionId }} }
                        // sepa mandate associated
                        else -> collections.any {
                            SepaCollectionReferenceId(subscription.shareOfferId) in (sepaCollectionIdToReferences[it]?:emptyList())
                        }
                    }
                }?: true

                matchesFiscalYears
                        && matchesShareTypes
                        && matchesStatuses
                        && matchesAhcAuthorized
                        && matchesUserProfiles
                        && matchesDistributionPoints
                        && matchesSepaCollections
            }
                // Treat checks
                .map{
                    it.copy(checked = checkedMap[it.shareSubscription.shareSubscriptionId] ?: false)
                }
            // Keep checks on visible items only
            checkedMap.clear()
            checkedMap.putAll(filteredCheckedSubscriptions.associateBy({it.shareSubscription.shareSubscriptionId}) { it.checked })
            uiState.write(uiState.read().copy(filter = filter))
        }

        ListWrapper(cardListStyles.listWrapper) {

            TitleWrapper(/*{width(90.percent)}*/) {
                Title { H3 { Text("Share Subscriptions") } }
                Horizontal(styles = {
                    flexGrow(1.0)
                    justifyContent(JustifyContent.FlexEnd)
                }) {
                    var newShareSubscriptionState by remember { mutableStateOf<ShareSubscription?>(null) }
                    When(opened) {
                        PlusButton(
                            color = Color.black,
                            bgColor = Color.white,
                            deviceType = deviceType,
                            isDisabled = false
                        ) {
                            shareManagementModals.showUpsertShareSubscriptionModal(
                                shareManagementStore,
                                upsertShareSubscriptionModalTexts.emit(),
                                deviceType,
                                UpsertShareSubscriptionModalConfiguration.configure(null, ChangedBy.PROVIDER),
                                Read(fiscalYears),
                                Read(distributionPoints),
                                Read(shareOffers),
                                providerId,
                                Read(membersAsUsers),
                                ChangedBy.PROVIDER,
                                {
                                    newShareSubscriptionState?.userProfileId == null
                                            || newShareSubscriptionState?.distributionPointId == null
                                            || newShareSubscriptionState?.shareOfferId == null
                                            || newShareSubscriptionState?.fiscalYearId == null
                                            || newShareSubscriptionState?.status == null
                                            || newShareSubscriptionState?.ahcAuthorized == null
                                },
                                null,
                                { data -> newShareSubscriptionState = data }
                            ) {
                                if (newShareSubscriptionState != null) {
                                    val data = requireNotNull(newShareSubscriptionState)
                                    scope.launch {
                                        with(data) {
                                            shareManagementActions dispatch createShareSubscription(
                                                providerId.value,
                                                shareOfferId,
                                                userProfileId,
                                                distributionPointId,
                                                fiscalYearId,
                                                numberOfShares,
                                                pricePerShare,
                                                ahcAuthorized,
                                                coSubscribers,
                                            )
                                        }
                                    }
                                }
                            }
                        }
                    }
                    CardChevrons(
                        texts = Source{ cardChevronTexts() },
                        deviceType = deviceType,
                        opened = opened
                    ) {
                        opened = it
                    }
                }
            }
            When(opened) {
                HeaderWrapper {
                    Horizontal({
                        width(80.percent)
                        alignSelf(AlignSelf.End)
                    }) {
                        val fiscalYearOptions: Map<String, List<FiscalYearId>> =
                            fiscalYears.read().groupBy { it.format() }.map { (year, fiscalYears) ->
                                year to fiscalYears.map { FiscalYearId(it.fiscalYearId) }
                            }.associateBy({ it.first }) { it.second }
                                .let {
                                    it.toMutableMap().apply {
                                        this["All Years"] = emptyList()
                                    }
                                }
                        var selectedFiscalYear by remember {
                            val filteredFiscalYears = uiState.read().filter.fiscalYears
                            mutableStateOf(when{
                                filteredFiscalYears == null -> "All Years"
                                filteredFiscalYears.isEmpty() -> "All Years"
                                else -> fiscalYears.filter { FiscalYearId(it.fiscalYearId) in filteredFiscalYears }.first().format()
                            })
                            //mutableStateOf("All Years")
                        }
                        Dropdown(
                            fiscalYearOptions,
                            selectedFiscalYear,
                            iconContent = { opened -> SimpleUpDown(opened) }
                        ) { (key, value) ->
                            filter = filter.copy(
                                fiscalYears = when {
                                    value.isEmpty() -> null
                                    else -> value
                                }
                            )
                            selectedFiscalYear = key
                        }

                        var selectedShareType by remember {
                            val filteredShareTypes = uiState.read().filter.shareTypes
                            val shareType = when{
                                filteredShareTypes.isNullOrEmpty() -> "All Shares"
                                else -> shareTypes.filter{ShareTypeId(it.shareTypeId) in filteredShareTypes}.first().name
                            }
                            mutableStateOf(shareType)
                        }
                        val shareTypeOptions = shareTypes.read().groupBy { it.name }.let {
                            it.toMutableMap<String, List<ShareType>?>().apply {
                                this["All Shares"] = null
                            }
                        }
                        Dropdown(
                            shareTypeOptions,
                            selectedShareType,
                            iconContent = { opened -> SimpleUpDown(opened) }
                        ) { (key, shareTypes) ->
                            selectedShareType = key
                            filter = filter.copy(
                                shareTypes = when {
                                    shareTypes == null -> null
                                    else -> shareTypes.map { ShareTypeId(it.shareTypeId) }
                                }
                            )
                        }

                        var selectedStatus by remember {
                            val statuses = uiState.read().filter.statuses
                            val status = when {
                                statuses.isNullOrEmpty() -> "All Statuses"
                                else -> statuses.first().value

                            }
                            mutableStateOf(status)
                        }
                        val statusOptions = mapOf(
                            "All Statuses" to null,
                            ShareStatus.ActivationRejected.value to ShareStatus.ActivationRejected,
                            ShareStatus.AwaitingAhcAuthorization.value to ShareStatus.AwaitingAhcAuthorization,
                            ShareStatus.Cancelled.value to ShareStatus.Cancelled,
                            ShareStatus.ClearedForAuction.value to ShareStatus.ClearedForAuction,
                            ShareStatus.Expired.value to ShareStatus.Expired,
                            ShareStatus.External.value to ShareStatus.External,
                            ShareStatus.Paused.value to ShareStatus.Paused,
                            ShareStatus.PaymentFailed.value to ShareStatus.PaymentFailed,
                            ShareStatus.PendingActivation.value to ShareStatus.PendingActivation,
                            ShareStatus.RolledOver.value to ShareStatus.RolledOver,
                            ShareStatus.RollingOver.value to ShareStatus.RollingOver,
                            ShareStatus.Subscribed.value to ShareStatus.Subscribed,
                            ShareStatus.Suspended.value to ShareStatus.Suspended,
                        )
                        Dropdown(
                            statusOptions,
                            selectedStatus,
                            iconContent = { opened -> SimpleUpDown(opened) }
                        ) { (key, status) ->
                            selectedStatus = key
                            filter = filter.copy(
                                statuses = when {
                                    status == null -> null
                                    else -> listOf(status)
                                }
                            )
                        }

                        var selectedAhcAuthorized by remember {
                            val filteredAhcAuthorized = uiState.read().filter.isAhcAuthorized
                            val ahcAuthorized = when{
                                filteredAhcAuthorized == true -> CHECK_TRUE
                                filteredAhcAuthorized == false -> CHECK_FALSE
                                else -> "All Auth"
                            }
                            mutableStateOf(ahcAuthorized)
                        }
                        val ahcAuthorizedOptions = mapOf(
                            "All Authorized" to null,
                            CHECK_TRUE to true,
                            CHECK_FALSE to false,
                        )
                        Dropdown(
                            ahcAuthorizedOptions,
                            selectedAhcAuthorized,
                            iconContent = { opened -> SimpleUpDown(opened) }
                        ) { (key, ahcAuthorized) ->
                            selectedAhcAuthorized = key
                            filter = filter.copy(
                                isAhcAuthorized = ahcAuthorized
                            )
                        }

                        var selectedDistributionPoint by remember {
                            val filteredDistributionPoints = uiState.read().filter.distributionPoints
                            val distributionPoint = when{
                                filteredDistributionPoints.isNullOrEmpty() -> "All Depots"
                                else -> distributionPoints.filter{it.distributionPointId in filteredDistributionPoints}.first().name
                            }

                            mutableStateOf(distributionPoint)
                        }
                        val distributionPointOptions = distributionPoints.read().groupBy { it.name }.let {
                            it.toMutableMap<String, List<DistributionPoint>?>().apply {
                                this["All Deports"] = null
                            }
                        }
                        Dropdown(
                            distributionPointOptions,
                            selectedDistributionPoint,
                            iconContent = { opened -> SimpleUpDown(opened) }
                        ) { (key, value) ->
                            selectedDistributionPoint = key
                            filter = filter.copy(
                                distributionPoints = when {
                                value == null -> null
                                else -> value.map { it.distributionPointId }
                            }
                            )
                        }
                        var selectedSepaCollections by remember {
                            val filteredSepaCollections = uiState.read().filter.sepaCollections
                            val sepaCollections = when{
                                filteredSepaCollections.isNullOrEmpty() -> "All Sepa"
                                else -> sepaCollections.filter{it.sepaCollectionId in filteredSepaCollections}.first().collectionKey.value
                            }

                            mutableStateOf(sepaCollections)
                        }
                        val sepaCollectionsOptions = sepaCollections.read()
                            .groupBy { "${it.collectionKey.value} / ${it.mandateReferencePrefix.value}" }.let {
                            it.toMutableMap<String, List<SepaCollection>?>().apply {
                                this["All Sepa"] = null
                                this["No Sepa"] = listOf(SepaCollection.EMPTY)
                            }
                        }
                        Dropdown(
                            sepaCollectionsOptions,
                            selectedSepaCollections,
                            styles = dropdownStyles.modifyContainerStyle { width(250.px) },
                            iconContent = { opened -> SimpleUpDown(opened) }

                        ) { (key, value) ->
                            selectedSepaCollections = key
                            filter = filter.copy(
                                sepaCollections = when {
                                value == null -> null
                                // value == listOf(SepaCollection.EMPTY) -> listOf(SepaCollectionId(NIL_UUID))
                                else -> value.map { it.sepaCollectionId }
                            })
                        }

                        var searchText by remember {
                            mutableStateOf(filter.userProfiles?.joinToString(",") { it }.orEmpty())
                        }
                        SearchInput(searchText, SearchInputStyles()) { text ->
                            searchText = text
                            filter = filter.copy(
                                userProfiles = when {
                                    text.isEmpty() -> null
                                    else -> text.split(",").map { it.trim() }
                                }
                            )
                        }
                        var bulksEditShareSubscriptionChanges by remember {
                            mutableStateOf<BulkEditShareSubscriptionChanges>(
                                BulkEditShareSubscriptionChanges.None
                            )
                        }
                        var shareSubscriptionsState by remember {
                            mutableStateOf<List<ShareSubscription>>(
                                filteredCheckedSubscriptions.map { it.shareSubscription }
                            )
                        }
                        LaunchedEffect(filter, checkedMap.filter { it.value }.keys, allChecked) {
                            shareSubscriptionsState =
                                filteredCheckedSubscriptions.filter { it.checked }.map { it.shareSubscription }
                        }
                        BulkEditButton(
                            color = Color.black,
                            bgColor = Color.white,
                            deviceType = deviceType,
                            isDisabled = checkedSubscriptions.none { it.checked }
                        ) {
                            shareManagementModals.showBulkEditShareShareSubscriptionsModal(
                                storage = shareManagementStore,
                                texts = defaultBulkEditTexts(),
                                device = deviceType,
                                modifier = ModifierId(currentUserId.read()),
                                fiscalYears = fiscalYears.read(),
                                shareOffers = shareOffers.read(),
                                distributionPoints = distributionPoints.read(),
                                shareSubscriptions = shareSubscriptionsState,
                                sepaCollections = sepaCollections.read(),
                                creditorIdentifier = creditorIdentifier.read(),
                                setChanges = { changes -> bulksEditShareSubscriptionChanges = changes }
                            ) {

                                shareManagementModals.showDialogModal(
                                    texts = dialogModalTexts("Are you sure you want to bulk edit share subscriptions?"),
                                    device = deviceType,
                                    symbol = { WarningSymbol(deviceType = deviceType.emit()) },
                                    onCancel = {},
                                ) {
                                    scope.launch {
                                        when (val changes = bulksEditShareSubscriptionChanges) {
                                            is BulkEditShareSubscriptionChanges.None -> Unit
                                            is BulkEditShareSubscriptionChanges.Status ->
                                                shareSubscriptionsState.forEach { shareSubscription ->
                                                    shareManagementActions dispatch updateShareStatus(
                                                        UpdateShareStatus(
                                                            providerId,
                                                            ShareSubscriptionId(shareSubscription.shareSubscriptionId),
                                                            changes.status.toApiType(),
                                                            changes.reason.toApiType(),
                                                            changes.changedBy.toApiType(),
                                                            changes.modifier,
                                                            changes.comment.orEmpty()
                                                        ),
                                                    )
                                                }
                                            is BulkEditShareSubscriptionChanges.Rollover ->
                                                shareManagementActions dispatch rolloverShareSubscriptions(
                                                    providerId = providerId,
                                                    shareSubscriptionIds = shareSubscriptionsState.map { ShareSubscriptionId( it.shareSubscriptionId) },
                                                    toShareOfferId = changes.shareOfferId,
                                                    changedBy = ChangedBy.PROVIDER,
                                                    modifiedBy = UserId(changes.modifier.value)
                                                )
                                            is BulkEditShareSubscriptionChanges.AddShareOffer ->
                                                shareSubscriptionsState.forEach { shareSubscription ->
                                                    shareManagementActions dispatch createShareSubscription(
                                                        providerId.value,
                                                        changes.shareOfferId,
                                                        shareSubscription.userProfileId,
                                                        shareSubscription.distributionPointId,
                                                        changes.fiscalYearId,
                                                        changes.numberOfShares,
                                                        changes.pricePerShare,
                                                        changes.isAhcAuthorized,
                                                        emptyList(),
                                                    )
                                                }

                                            is BulkEditShareSubscriptionChanges.AddSepaMandate -> {
                                                val forbiddenStatuses = listOf(
                                                    ShareStatus.Suspended,
                                                    ShareStatus.Cancelled,
                                                    // ShareStatus.AwaitingAhcAuthorization,
                                                )
                                                shareSubscriptionsState.filter { it.status !in forbiddenStatuses }
                                                    .forEachIndexed { index, shareSubscription ->
                                                        val debtorBankAccount =
                                                            userProfileToBankAccountMap[shareSubscription.userProfileId]
                                                        requireNotNull(shareSubscription.pricePerShare) {
                                                            "Price per share needs to be set!!"
                                                        }
                                                        // Leave out subscriptions of users without bank account
                                                        if (debtorBankAccount == null) return@forEachIndexed
                                                        bankingApplicationActions dispatch createSepaMandate(
                                                            CreateSepaMandate(
                                                                creditorId = changes.creditorIdentifier.creditorId,
                                                                debtorBankAccountId = debtorBankAccount.bankAccountId,
                                                                debtorName = debtorBankAccount.bankAccountHolder,
                                                                mandateReference = changes.sepaCollection.mandateReferencePrefix.generateReference(
                                                                    changes.mandateReferencePadStart, 8, index
                                                                ),
                                                                mandateReferencePrefix = null,
                                                                signedAt = now(),
                                                                validFrom = now(),
                                                                validUntil = null,
                                                                status = changes.status.toApyType(),
                                                                isActive = changes.isActive,
                                                                amendmentOf = null,
                                                                collectionId = changes.sepaCollection.sepaCollectionId,
                                                                sepaMandateReferenceData = CreateSepaMandateReferenceData(
                                                                    referenceId = SepaMandateReferenceId(
                                                                        shareSubscription.shareSubscriptionId
                                                                    ),
                                                                    amount = shareSubscription.numberOfShares.toDouble() * shareSubscription.pricePerShare
                                                                )
                                                            ),
                                                            targetCollectionId = changes.sepaCollection.sepaCollectionId,
                                                        )
                                                    }
                                            }

                                            is BulkEditShareSubscriptionChanges.Trivial -> when (val trChanges: BulkEditShareSubscriptionChanges.Trivial =
                                                changes) {
                                                is BulkEditShareSubscriptionChanges.Trivial.PricePerShare ->
                                                    shareSubscriptionsState.forEach { shareSubscription ->
                                                        shareManagementActions dispatch updateShareSubscription(
                                                            shareSubscription.shareSubscriptionId,
                                                            providerId.value,
                                                            shareSubscription.shareOfferId,
                                                            shareSubscription.userProfileId,
                                                            shareSubscription.status,
                                                            shareSubscription.distributionPointId,
                                                            shareSubscription.fiscalYearId,
                                                            shareSubscription.numberOfShares,
                                                            trChanges.pricePerShare,
                                                            shareSubscription.ahcAuthorized,
                                                            shareSubscription.coSubscribers.map { Username(it) },
                                                        )

                                                    }

                                                is BulkEditShareSubscriptionChanges.Trivial.NumberOfShares ->
                                                    shareSubscriptionsState.forEach { shareSubscription ->
                                                        shareManagementActions dispatch updateShareSubscription(
                                                            shareSubscription.shareSubscriptionId,
                                                            providerId.value,
                                                            shareSubscription.shareOfferId,
                                                            shareSubscription.userProfileId,
                                                            shareSubscription.status,
                                                            shareSubscription.distributionPointId,
                                                            shareSubscription.fiscalYearId,
                                                            trChanges.numberOfShares,
                                                            shareSubscription.pricePerShare,
                                                            shareSubscription.ahcAuthorized,
                                                            shareSubscription.coSubscribers.map { Username(it) },
                                                        )
                                                    }

                                                is BulkEditShareSubscriptionChanges.Trivial.DistributionPoint ->
                                                    shareSubscriptionsState.forEach { shareSubscription ->
                                                        shareManagementActions dispatch updateShareSubscription(
                                                            shareSubscription.shareSubscriptionId,
                                                            providerId.value,
                                                            shareSubscription.shareOfferId,
                                                            shareSubscription.userProfileId,
                                                            shareSubscription.status,
                                                            trChanges.distributionPointId,
                                                            shareSubscription.fiscalYearId,
                                                            shareSubscription.numberOfShares,
                                                            shareSubscription.pricePerShare,
                                                            shareSubscription.ahcAuthorized,
                                                            shareSubscription.coSubscribers.map { Username(it) },
                                                        )
                                                    }

                                                is BulkEditShareSubscriptionChanges.Trivial.AhcAuthorization ->
                                                    shareSubscriptionsState.forEach { shareSubscription ->
                                                        shareManagementActions dispatch updateShareSubscription(
                                                            shareSubscription.shareSubscriptionId,
                                                            providerId.value,
                                                            shareSubscription.shareOfferId,
                                                            shareSubscription.userProfileId,
                                                            shareSubscription.status,
                                                            shareSubscription.distributionPointId,
                                                            shareSubscription.fiscalYearId,
                                                            shareSubscription.numberOfShares,
                                                            shareSubscription.pricePerShare,
                                                            trChanges.isAhcAuthorized,
                                                            shareSubscription.coSubscribers.map { Username(it) },
                                                        )
                                                    }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        var bulkUpdateShareSubscriptionsState by remember { mutableStateOf<ShareSubscriptions?>(null) }
                        val initialShareSubscriptions = {
                            filteredCheckedSubscriptions.filter {
                                it.checked
                            }.map { s ->
                                val username =
                                    userProfileToUserMap[s.shareSubscription.userProfileId]!!.username
                                Username(username) to s.shareSubscription
                            }.associateBy({
                                it.first
                            }) { it.second }
                        }
                        UploadButton(
                            color = Color.black,
                            bgColor = Color.white,
                            deviceType = deviceType,
                            isDisabled = false
                        ) {
                            shareManagementModals.showBulkUpdateShareDataByFileImportModal(
                                texts = dialogModalTexts("BulkEdit by import"),
                                device = deviceType,
                                shareSubscriptions = initialShareSubscriptions(),
                                setShareSubscriptions = {
                                    bulkUpdateShareSubscriptionsState = it
                                }
                            ) {
                                shareManagementModals.showDialogModal(
                                    texts = dialogModalTexts("Are you sure you want to bulk edit share subscriptions?"),
                                    device = deviceType,
                                    symbol = { WarningSymbol(deviceType = deviceType.emit()) },
                                    onCancel = {},
                                ) {
                                    scope.launch {
                                        bulkUpdateShareSubscriptionsState?.all?.forEach { shareSubscription ->
                                            shareManagementActions dispatch updateShareSubscription(
                                                shareSubscription.shareSubscriptionId,
                                                providerId.value,
                                                shareSubscription.shareOfferId,
                                                shareSubscription.userProfileId,
                                                shareSubscription.status,
                                                shareSubscription.distributionPointId,
                                                shareSubscription.fiscalYearId,
                                                shareSubscription.numberOfShares,
                                                shareSubscription.pricePerShare,
                                                shareSubscription.ahcAuthorized,
                                                shareSubscription.coSubscribers.map { Username(it) },
                                            )
                                        }
                                        bulkUpdateShareSubscriptionsState = null
                                    }
                                }
                            }
                        }
                    }
                }
                HeaderWrapper {
                    Header(cardListStyles.header) {
                        CheckBoxCell({ allChecked }, { width(2.percent) }) {
                            val newCheckedState = !allChecked
                            checkedMap.clear()
                            if (newCheckedState) {
                                checkedMap.putAll(filteredCheckedSubscriptions.associateBy({ it.shareSubscription.shareSubscriptionId }) { true })
                            }
                            allChecked = newCheckedState
                        }
                        HeaderCell("Fiscal Year") { width(10.percent) }
                        HeaderCell("Share Type") { width(15.percent) }
                        HeaderCell("Status") { width(20.percent) }
                        HeaderCell("No") { width(5.percent) }
                        HeaderCell("Price") { width(5.percent) }
                        HeaderCell("Depot") { width(10.percent) }
                        HeaderCell("User") { width(20.percent) }
                        HeaderCell("SEPA") { width(5.percent) }
                        HeaderCell("SEPA - Collection Key / Mandate Ref Pref") { width(20.percent) }
                    }
                }
                val checksChanged = checkedMap.filter { it.value }.keys

                VirtualScrollableList(
                    items = filteredCheckedSubscriptions,
                    itemHeight = 44.0,
                    styles = ScrollableStyles()
                        .modifyContainerStyle {
                            height(80.vh)
                            flexDirection(FlexDirection.RowReverse)
                        }
                        .modifyContentStyle {
                            flexGrow(1)
                        }
                ) { index, checkedSubscription ->
                        val checked = checkedSubscription.checked
                        val subscription = checkedSubscription.shareSubscription
                        key(index, allChecked, checksChanged, checked, subscription) {
                            ListItemWrapper({
                                listItemWrapperStyle(this, index)
                            }) {
                                DataWrapper(cardListStyles.dataWrapper) {
                                    var checkedState by remember { mutableStateOf(checked) }
                                    CheckBoxCell({ checkedState }, { width(2.percent) }) {
                                        checkedMap[subscription.shareSubscriptionId] = !checkedState
                                        checkedState = !checkedState
                                    }
                                    TextCell(
                                        fiscalYearsMap[subscription.fiscalYearId]?.format() ?: ""
                                    ) { width(10.percent) }
                                    TextCell(
                                        shareOffersMap[subscription.shareOfferId]?.shareType?.name ?: ""
                                    ) { width(15.percent) }
                                    TextCell(subscription.status.value) { width(20.percent) }
                                    NumberCell(subscription.numberOfShares) { width(5.percent) }
                                    NumberCell(subscription.pricePerShare ?: 0) { width(5.percent) }

                                    TextCell(
                                        distributionPointsMap[subscription.distributionPointId]?.name ?: ""
                                    ) { width(10.percent) }
                                    TextCell(
                                        userProfilesMap[subscription.userProfileId]?.fullname() ?: ""
                                    ) { width(20.percent) }
                                    TextCell(subscription.ahcAuthorized.checkIcon("--")) { width(5.percent) }
                                    /*
                                    TextCell(
                                        associatedCollection?.let { sC ->
                                            "${sC.collectionKey.value} / ${sC.mandateReferencePrefix.value}"
                                        } ?: "--"
                                    ) {
                                        width(20.percent)
                                        overflow(Overflow.Hidden)
                                    }

                                     */

                                    TextCell(sepaCollections.read().filter { coll ->
                                        coll.refersTo(subscription) && subscription.relatedBankAccountExists(
                                            coll,
                                            userProfileToBankAccountMap
                                        ) && subscription.hasAssociatedSepaMandate(shareSubscriptionIdToMandateMap.emit())
                                    }.joinToString(", ") { sC ->
                                        "${sC.collectionKey.value} / ${sC.mandateReferencePrefix.value}"
                                    }) {
                                        width(20.percent)
                                        overflow(Overflow.Hidden)
                                    }


                                }
                                ActionsWrapper {

                                    val allowedTransferStatuses = listOf(
                                        ShareStatus.PendingActivation,
                                        ShareStatus.Subscribed
                                    )

                                    var newOwnerState by remember { mutableStateOf<UserProfile?>(null) }

                                    UserGearButton(
                                        texts = {"Transfer subscription to other member"},
                                        color = Color.black,
                                        bgColor = Color.white,
                                        deviceType = deviceType,
                                        isDisabled = subscription.status !in allowedTransferStatuses
                                    ) {

                                        shareManagementModals.showTransferOwnershipOfShareSubscriptionModal(
                                            storage = shareManagementStore,
                                            texts = transferOwnershipOfShareSubscriptionModalTexts.emit(),
                                            device = deviceType,
                                            providerId = providerId,
                                            users = Read(membersAsUsers),
                                            changesDoneBy = ChangedBy.PROVIDER,
                                            shareSubscription = subscription,
                                            isOkButtonDisabled = {
                                                newOwnerState == null
                                            },
                                            newOwner = newOwnerState,
                                            setNewOwner = { newOwnerState = it }
                                        ) {
                                            val newOwnerId =
                                                requireNotNull(newOwnerState) { "Owner id must not be null" }.userProfileId

                                            scope.launch {
                                                shareManagementActions dispatch transferOwnership(
                                                    providerId,
                                                    ShareSubscriptionId(subscription.shareSubscriptionId),
                                                    UserProfileId(newOwnerId),
                                                )
                                            }
                                        }

                                    }


                                    val associatedCollections = shareSubscriptionToCollectionsMap.emit()[ShareSubscriptionId(subscription.shareSubscriptionId)]
                                    val availableCollections = Read(sepaCollections * FilterBy { subscription.shareOfferId in it.referenceIds.map { ref -> ref.value } }) * Emit

                                    val collections = associatedCollections ?: availableCollections

                                    val initialMandate = when {
                                        associatedCollections != null -> shareSubscriptionIdToMandateMap.emit()[ShareSubscriptionId(subscription.shareSubscriptionId)]
                                        else -> null
                                    }
                                    var activeSepaMandate by remember { mutableStateOf<SepaMandate?>(initialMandate) }

                                    val creditorId = creditorIdentifier.read()?.creditorId
                                    val bankAccount = userProfileToBankAccountMap[subscription.userProfileId]
                                    val usersSepaMandates = sepaMandates map { mandates -> mandates.filter { it.debtorBankAccountId == bankAccount?.bankAccountId } }

                                    val initialMode = if (usersSepaMandates.emit().isNotEmpty()) AttachOrUpsertSepaMandateModalMode.Attach else AttachOrUpsertSepaMandateModalMode.Upsert
                                    var modeState by remember { mutableStateOf<AttachOrUpsertSepaMandateModalMode>(initialMode) }

                                    CreditCardButton(
                                        color = Color.black,
                                        bgColor = Color.white,
                                        deviceType = deviceType,
                                        isDisabled = bankAccount == null ||  collections.isEmpty() || creditorId == null
                                    ) {
                                        shareManagementModals.showAttachOrUpsertSepaMandateModal(
                                            storage = bankingApplicationStorage,
                                            device = deviceType,
                                            bankAccount = bankAccount,
                                            collections = collections,
                                            usersSepaMandates = usersSepaMandates.emit(),
                                            mode = modeState,
                                            setMode = { modeState = it },
                                            sepaMandate = activeSepaMandate,
                                            setSepaMandate = { activeSepaMandate = it },
                                            texts = attachOrUpsertSepaMandateModalTexts
                                        ) {
                                            scope.launch {
                                                val amount = (subscription.pricePerShare ?: 0.0) * subscription.numberOfShares
                                                val targetCollectionId = collections.firstOrNull { coll ->
                                                    subscription.shareOfferId in coll.referenceIds.map { it.value }
                                                }?.sepaCollectionId ?: collections.firstOrNull()?.sepaCollectionId

                                                when (modeState) {
                                                    is AttachOrUpsertSepaMandateModalMode.Attach -> {
                                                        val mandate = activeSepaMandate
                                                        if (mandate != null) {
                                                            bankingApplicationActions dispatch attachSepaMandateReferenceData(
                                                                AttachSepaMandateReferenceData(
                                                                    sepaMandateId = mandate.sepaMandateId,
                                                                    referenceId = SepaMandateReferenceId(subscription.shareSubscriptionId),
                                                                    collectionId = targetCollectionId,
                                                                    amount = amount
                                                                )
                                                            )
                                                        }
                                                    }
                                                    is AttachOrUpsertSepaMandateModalMode.Upsert -> {
                                                        val mandate = activeSepaMandate
                                                        if (mandate != null && creditorId != null && bankAccount != null) {
                                                            val isNewSepaMandate = mandate.sepaMandateId.value == NIL_UUID
                                                            val collectionId = mandate.collectionId ?: targetCollectionId
                                                            requireNotNull(collectionId) { "Collection of mandate must not be null" }

                                                            if (isNewSepaMandate) {
                                                                val mandateReferencePrefix = collections
                                                                    .firstOrNull { it.sepaCollectionId == collectionId }
                                                                    ?.mandateReferencePrefix
                                                                bankingApplicationActions dispatch createSepaMandate(
                                                                    CreateSepaMandate(
                                                                        debtorBankAccountId = mandate.debtorBankAccountId,
                                                                        debtorName = mandate.debtorName,
                                                                        mandateReference = null,
                                                                        signedAt = mandate.signedAt,
                                                                        validFrom = mandate.validFrom,
                                                                        validUntil = mandate.validUntil,
                                                                        status = mandate.status.toApyType(),
                                                                        isActive = mandate.isActive,
                                                                        amendmentOf = mandate.amendmentOf,
                                                                        creditorId = creditorId,
                                                                        collectionId = collectionId,
                                                                        mandateReferencePrefix = mandateReferencePrefix,
                                                                        sepaMandateReferenceData = CreateSepaMandateReferenceData(
                                                                            referenceId = SepaMandateReferenceId(subscription.shareSubscriptionId),
                                                                            amount = amount
                                                                        ),
                                                                    ),
                                                                    collectionId,
                                                                )
                                                            } else {
                                                                bankingApplicationActions dispatch updateSepaMandateInSepaCollection(
                                                                    UpdateSepaMandate(
                                                                        sepaMandateId = mandate.sepaMandateId,
                                                                        debtorBankAccountId = mandate.debtorBankAccountId,
                                                                        debtorName = mandate.debtorName,
                                                                        mandateReference = mandate.mandateReference,
                                                                        signedAt = mandate.signedAt,
                                                                        validFrom = mandate.validFrom,
                                                                        validUntil = mandate.validUntil,
                                                                        status = mandate.status.toApyType(),
                                                                        isActive = mandate.isActive,
                                                                        amendmentOf = mandate.amendmentOf,
                                                                        creditorId = creditorId,
                                                                        lastUsedAt = mandate.lastUsedAt,
                                                                        collectionId = collectionId,
                                                                    ),
                                                                    targetCollectionId = collectionId
                                                                )
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }


                                    var newShareSubscriptionState by remember { mutableStateOf(subscription) }
                                    EditButton(
                                        color = Color.black,
                                        bgColor = Color.white,
                                        deviceType = deviceType,
                                        isDisabled = false
                                    ) {
                                        shareManagementModals.showUpsertShareSubscriptionModal(
                                            shareManagementStore,
                                            upsertShareSubscriptionModalTexts.emit(),
                                            deviceType,
                                            UpsertShareSubscriptionModalConfiguration.configure(subscription, ChangedBy.PROVIDER),
                                            Read(fiscalYears),
                                            Read(distributionPoints),
                                            Read(shareOffers),
                                            providerId,
                                            Read(membersAsUsers),
                                            ChangedBy.PROVIDER,
                                            { false },
                                            subscription,
                                            { data -> newShareSubscriptionState = data }
                                        ) {
                                            scope.launch {
                                                with(newShareSubscriptionState) {
                                                    shareManagementActions dispatch updateShareSubscription(
                                                        shareSubscriptionId,
                                                        providerId.value,
                                                        shareOfferId,
                                                        userProfileId,
                                                        status,
                                                        distributionPointId,
                                                        fiscalYearId,
                                                        numberOfShares,
                                                        pricePerShare,
                                                        ahcAuthorized,
                                                        coSubscribers.map { Username(it) },
                                                    )
                                                }
                                            }
                                        }
                                    }
                                    TrashCanButton(
                                        color = Color.black,
                                        bgColor = Color.white,
                                        deviceType = deviceType,
                                        isDisabled = true
                                    ) {}
                                }
                            }
                        }

                }
            }
        }
    }
}

fun shareManagementForOrganizationsTexts(): Source<Lang.Block> = {
    "shareManagementForOrganizations" texts {
        "shareTypesManagement" block {
            "title" colon "Share Types"
        }
        "shareOfferManagement" block {
            "item" block {
                "actions" block {
                    "attachSepaCollection" block {
                        "hints" block {
                            "noCreditorsDefined" colon "No Creditors defined"
                        }
                        "tooltip" block {
                            "title" colon "Attach or update Sepa Collection"
                        }
                    }
                }
            }
        }
        "shareSubscriptionManagement" block {
            "title" colon "Share Subscriptions"
        }

        "dialogs" block {
            "attachSepaCollectionModal" block {
                "x" colon "Y"
            }
        }
    }
}
